import type { components } from '../../api/generated/schema'

type Schema = components['schemas']

/**
 * Display labels for the two world-building enums.
 *
 * Presentation only, exactly as `domains/characters/labels.ts`: the values come from
 * the server, nothing here decides behaviour, and anything unknown falls through to
 * the raw name so a value added server-side shows up as itself rather than vanishing.
 */

const RELATIONSHIPS: Record<string, string> = {
  Enemy: 'Enemy',
  Allied: 'Allied',
  Neutral: 'Neutral',
}

const MEMBER_ROLES: Record<string, string> = {
  Member: 'Member',
  PersonalEnemy: 'Personal enemy',
  Friend: 'Friend',
}

export const relationshipLabel = (value: string): string => RELATIONSHIPS[value] ?? value
export const memberRoleLabel = (value: string): string => MEMBER_ROLES[value] ?? value

export const RELATIONSHIP_ORDER: Array<Schema['RelationshipType']> = ['Allied', 'Neutral', 'Enemy']

export const MEMBER_ROLE_ORDER: Array<Schema['MemberRole']> = ['Member', 'Friend', 'PersonalEnemy']

/**
 * The chip tone a relationship reads as. `Enemy` is the only one that earns the harm
 * colour — the spec reserves blood-red for things that hurt you, and tinting all three
 * would spend the signal on nothing.
 */
export function relationshipTone(type: string): 'neutral' | 'consequence' {
  return type === 'Enemy' ? 'consequence' : 'neutral'
}
